import { RequiredQueryKeyFilter, createDefaultQueryKeysGenerator } from 'core/query/constants';

interface BoardQueryListKeyFilter extends RequiredQueryKeyFilter {
  team_id: number;
  is_integration?: boolean;
}

interface BoardQueryDetailKeyFilter extends RequiredQueryKeyFilter {
  board_id: number;
}

export const boardQueryKeys = createDefaultQueryKeysGenerator<
  BoardQueryListKeyFilter,
  BoardQueryDetailKeyFilter
>({ keyDataType: 'boards' });
